<template>
  <div class="footer">
    <ButtonPrimary
      size="large"
      :label="leftButtonText"
      class="footer__btn"
      :loading="isLoading"
      :disabled="disabled"
      @click="onLeftButtonClick"
    />
    <ButtonPrimary
      v-if="showRightButton"
      :label="rightButtonText"
      :loading="isLoading"
      :disabled="disabled"
      class="footer__btn footer__another-wallet"
      @click="onRightButtonClick"
    />
  </div>
</template>
<script lang="ts">
import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

import { ButtonPrimary } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  name: 'Footer',
  components: { ButtonPrimary }
})
export default class Footer extends Vue {
  readonly NebraskaColors = NebraskaColors;

  @Prop({ type: Boolean, required: false, default: false })
  public readonly showRightButton!: boolean;

  @Prop({ type: String, required: true })
  public readonly leftButtonText!: string;

  @Prop({ type: String, required: false })
  public readonly rightButtonText!: string;

  @Prop({ type: Boolean, default: false })
  public readonly isLoading!: boolean;

  @Prop({ type: Boolean, default: false })
  public disabled?: boolean;

  @Emit()
  onLeftButtonClick() {}

  @Emit()
  onRightButtonClick() {}
}
</script>

<style lang="less" scoped>
.footer {
  display: flex;
  justify-content: center;
  border-top: @size-border-x400 solid @divider-primary;
  background: @background-secondary;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;

  &__btn {
    margin: @size-spacing-x400 @size-spacing-x150;
  }
  &__another-wallet {
    .to-sm({display: none;});
  }
}
</style>
